import React from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { darken } from "polished";
const ButtonWrapper = styled.button`
  display: flex;
  padding: 12px 24px;
  height: 44px;
  width: auto;
  align-items: center;
  gap: ${({ $showIcon }) => ($showIcon ? "8px" : "0")};
  border: none;
  border-radius: 16px;
  background: ${({ clr }) => `var(--ei-docta, ${clr.ctaPrimary})`};
  color: white;
  cursor: pointer;

  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

 &:hover {
  background: ${({ clr }) => darken(0.05, clr?.ctaPrimary)};
  transform: scale(1.03);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

  svg {
    width: 16px;
    height: 14px;
    fill: #fff;
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: scale(1.1);
  }
`;

const RightArrowPath = `m 23.534619,13.096857 c 0.172699,-0.193035 0.347486,-0.581504 0.351666,-0.972364 0.0041,-0.390861 -0.162243,-0.784119 -0.330765,-0.981943 L 14.282862,0.6530352 C 13.777309,0.0595601 12.92427,0.04758891 12.406175,0.62669867 11.888081,1.2058082 11.877631,2.1829621 12.383184,2.7764374 L 19.294503,10.691833 1.3806743,10.440439 C 0.52972484,10.233037 0.00954068,11.007579 0.00118018,11.789301 -0.0071803,12.571022 0.4962829,13.359929 1.3493223,13.3719 l 18.0844367,0.253789 -7.078528,7.719069 c -0.518094,0.579108 -0.528544,1.556263 -0.02299,2.149737 0.505553,0.593476 1.358593,0.605447 1.876687,0.02632 z`;

const StyledButton = ({ Linkto, text, showIcon = false }) => {
  const {
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const here = useLocation().pathname;
  const isActive = here.includes(Linkto);

  const handleUnitClick = () => {
    navigate(`/${language}${Linkto}`);
  };

  return (
    <ButtonWrapper clr={f_clr} onClick={handleUnitClick} active={isActive} $showIcon={showIcon}>
      <span className="eus-buton-1">{text}</span>
      {showIcon && (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d={RightArrowPath} />
        </svg>
      )}
    </ButtonWrapper>
  );
};

export default StyledButton;
